import { MESSAGE_SYSTEM_TYPE } from './worker-channel-hub.interface';
// eslint-disable-next-line @typescript-eslint/ban-types
export const hasProperty = (obj, prop) => typeof obj === 'object' && prop in obj;
// eslint-disable-next-line @typescript-eslint/ban-types
export const hasPropertyType = (obj, prop, type) => hasProperty(obj, prop) && typeof obj[prop] === type;
export const hasPropertyTypes = (...propertyCheckParams) => propertyCheckParams.every(propertyCheckParam => hasPropertyType(...propertyCheckParam));
export const isIComApiMessageSystem = (message) => hasPropertyTypes([message, 'id', 'string'], [message, 'type', 'string'], [message, 'message', 'string']) &&
    MESSAGE_SYSTEM_TYPE.includes(message['type']);
export const isIComApiMessage = (message) => hasPropertyTypes([message, 'version', 'string'], [message, 'topic', 'string'], [message, 'channel', 'string']);
export const healthCheck = async (workerChannelHub, lastId, deathDelay) => {
    lastId && clearTimeout(Number(lastId));
    setTimeout(() => {
        const id = setTimeout(() => {
            workerChannelHub.channels.forEach(provider => {
                provider.triggerDisconnection();
            });
        }, deathDelay);
        workerChannelHub.systemDispatch('healthCheck', 'checking', String(id));
    }, deathDelay);
};
